import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'list', 'count']
  static values = { url: String, genericError: String }

  connect() {
    this.observer = new MutationObserver(() => this.updateCount())
    this.observer.observe(this.listTarget, { childList: true })
    this.updateCount()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  updateCount() {
    if (!this.hasCountTarget) return

    this.countTarget.textContent = this.listTarget.childElementCount
  }

  open(event) {
    event?.preventDefault()

    this.inputTarget.click()
  }

  upload() {
    Array.from(this.inputTarget.files).forEach((file) => this.uploadOne(file))
    this.inputTarget.value = ''
  }

  uploadOne(file) {
    const placeholder = this.buildPlaceholder()
    this.listTarget.appendChild(placeholder)

    const body = new FormData()
    body.append('file', file)

    const request = new XMLHttpRequest()
    request.open('POST', this.urlValue)
    if (this.csrfToken) request.setRequestHeader('X-CSRF-Token', this.csrfToken)
    request.upload.addEventListener('progress', (event) => this.onProgress(event, placeholder))
    request.addEventListener('load', () => this.onLoad(request, placeholder))
    request.addEventListener('error', () => this.markFailed(placeholder, this.genericErrorValue))
    request.send(body)
  }

  onProgress(event, placeholder) {
    if (!event.lengthComputable) return

    placeholder.querySelector('progress').value = (event.loaded / event.total) * 100
  }

  onLoad(request, placeholder) {
    if (request.status >= 200 && request.status < 300) {
      placeholder.outerHTML = request.responseText
      return
    }

    this.markFailed(placeholder, request.status === 422 ? request.responseText : this.genericErrorValue)
  }

  markFailed(placeholder, message) {
    const text = document.createElement('p')
    text.className = 'text-danger'
    text.textContent = message

    const dismiss = document.createElement('button')
    dismiss.type = 'button'
    dismiss.textContent = 'x'
    dismiss.dataset.action = 'click->uploader#dismiss'

    placeholder.classList.add('file-upload__item--error')
    placeholder.setAttribute('role', 'alert')
    placeholder.replaceChildren(text, dismiss)
  }

  dismiss(event) {
    event.currentTarget.closest('.file-upload__item').remove()
  }

  buildPlaceholder() {
    const placeholder = document.createElement('div')
    placeholder.className = 'file-upload__item file-upload__item--uploading'
    placeholder.innerHTML = '<progress value="0" max="100"></progress>'

    return placeholder
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
